'use client';

import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import { cn } from '@/utils/tailwind-merge';

const AnimatedContent = ({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) => {
    const [ref, isVisible] = useIntersectionObserver({ threshold: 0.5 });

    return (
        <div
            ref={ref}
            className={cn(
                `text-xl md:text-[26px] text-gray-200 font-light transform transition-transform duration-700`,
                isVisible
                    ? 'translate-x-0 opacity-100'
                    : '-translate-x-full opacity-0 max-md:translate-x-0',
                className,
            )}
        >
            {children}
        </div>
    );
};

export default AnimatedContent;
